import React from 'react'
import {Box, Button, Drawer, styled, Typography} from "@mui/material"
import Terminformular from "./Terminformular"
import {useAuth} from "react-oidc-context"

const Headline = styled(Typography)(() => ({
    marginLeft: 25,
    marginTop: 25,
}))

const Subheadline = styled(Typography)(() => ({
    marginLeft: 25,
}))

const StyledButton = styled(Button)(() => ({
    maxWidth: "25%",
    marginRight: 20,
}))

const signout = (auth) => {
    auth.signoutRedirect({
        post_logout_redirect_uri: globalThis.location.origin,
    })
}

const Abmeldedrawer = ({open, setIsOpenAbmeldeDrawer}) => {
    const auth = useAuth()

    const handleCancelClick = () => {
        setIsOpenAbmeldeDrawer(false)
    }
    const handleLogoutClick = () => {
        sessionStorage.removeItem("initUrl")
        signout(auth)
    }

    return <Drawer
        open={open}
        anchor="right"
    >
        <Headline variant="h1">Abschlusscheck</Headline>
        <Subheadline variant="body">An alles gedacht?</Subheadline>
        <Terminformular/>
        <Box display="flex" justifyContent="flex-end">
            <StyledButton variant="tertiary" onClick={handleCancelClick}>Abbrechen</StyledButton>
            <StyledButton variant="primary" onClick={handleLogoutClick}>Fertig</StyledButton>
        </Box>
    </Drawer>
}

export default Abmeldedrawer